var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeserta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Icon peserta",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 38C143.464 38 156 50.536 156 66C156 81.464 143.464 94 128 94C112.536 94 100 81.464 100 66C100 50.536 112.536 38 128 38Z",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 69C69.703 69 80 79.297 80 92C80 104.703 69.703 115 57 115C44.297 115 34 104.703 34 92C34 79.297 44.297 69 57 69Z",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199 69C211.703 69 222 79.297 222 92C222 104.703 211.703 115 199 115C186.297 115 176 104.703 176 92C176 79.297 186.297 69 199 69Z",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81 207V164C81 143.565 97.565 127 118 127H138C158.435 127 175 143.565 175 164V207H81Z",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 197V158C33 141.431 46.431 128 63 128H75",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223 197V158C223 141.431 209.569 128 193 128H181",
    stroke: "#0B55B7",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeserta);
export default __webpack_public_path__ + "static/media/icon_peserta.964f336208bd4fd5d11ec4b7a4616b1f.svg";
export { ForwardRef as ReactComponent };